import { api, apiError } from "@/lib/api";
import { toast } from "sonner";

// Server decides the price; we only send the product id + our origin
export async function startCheckout(product) {
  try {
    const { data } = await api.post("/payments/checkout", { product, origin_url: window.location.origin });
    window.location.assign(data.checkout_url);
  } catch (e) {
    toast.error(apiError(e.response?.data?.detail) || "Couldn't open checkout");
    throw e;
  }
}
